import styles from './Dropdown.module.scss';
import React, {useRef, useState} from "react";

const POINTER_SIZE = 10;

interface Props {
    open?: boolean;
    toggle: React.ReactElement;
    children: React.ReactElement | React.ReactElement[] | undefined;
    onOpenChanged?: Function;
    position?: 'Under Right' | 'Under Left' | 'Right';
    stayOpenAfterClick?: boolean;
    changeState?: boolean;
    disabled?: boolean;
    hover?: boolean;
}
const Dropdown = (props: Props) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const getIsOpen = () => {
        return props.open ?? isOpen;
    }

    const containerRef = useRef<HTMLDivElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = (newValue: boolean | undefined = undefined) => {
        if (props.disabled) {
            return;
        }

        if (newValue === isOpen) {
            return;
        }

        if (props.onOpenChanged) {
            props.onOpenChanged(newValue ?? !getIsOpen());
        }

        setIsOpen(newValue ?? !getIsOpen());
    }

    const getPlacementStyle = () => {
        const dropDownBoundingRect = dropdownRef.current?.getBoundingClientRect();
        const containerBoundingRect = containerRef.current?.getBoundingClientRect();

        if (!containerBoundingRect || !dropDownBoundingRect) {
            return;
        }

        if (props.position === 'Right') {
            return {
                top: containerBoundingRect?.top!,
                left: containerBoundingRect?.x + containerBoundingRect?.width + POINTER_SIZE
            }
        }

        if (props.position === 'Under Left') {
            return {
                top: containerBoundingRect?.height + POINTER_SIZE,
                left: 0
            }
        }

        return {
            top: containerBoundingRect?.height + POINTER_SIZE,
            right: 0
        }
    }


    return (
        <>
            <div className={styles.container} ref={containerRef}>
                <div onClick={() => !props.hover && toggleDropdown(true)} onMouseEnter={() => props.hover && toggleDropdown(true)} onMouseLeave={() => props.hover && toggleDropdown(false)}>
                    {React.cloneElement(props.toggle, { style: { pointerEvents: 'none'}})}
                </div>

                <div className={`${styles.dropdown} ${getIsOpen() && styles.open}`}
                     ref={dropdownRef}
                     onClick={() => toggleDropdown()}
                     style={getPlacementStyle()}
                >
                    {props.children}

                </div>
            </div>
            <div style={props.hover ? {pointerEvents: 'none'} : {}} className={`${styles.backdrop} ${getIsOpen() && styles.open}`} onClick={() => toggleDropdown()} />
        </>
    )
}

export default Dropdown
